export default "https://cdn-static.gokick.com/assets/b96dd49a95534624185e45ca053b90dd739d9b4e/images/picture-of-you.b930d7b92f771d9006a5673f9ae1716c.svg";